/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";
import { stringify } from "qs";
import { token, channel_code, device_id, source, appversion, user_id, love_stock_pro_is_show_all,u_id, origin_user_id,bundle_name } from "@/utils/urlQuery";
import store from '@/store';

var base = '.aigupiao.com/', baseURL = "";

// 环境的切换
if (process.env.NODE_PM === "prod") {
    baseURL = "https://apis"+base;
} else if (process.env.NODE_PM === "dev") {
    baseURL = "https://apisdev"+base;
} else if (process.env.NODE_PM === "beta") {
    baseURL = "https://apisbeta"+base;
} else {
    baseURL = "https://apis"+base
    baseURL = "https://apisdev"+base
    // baseURL = "";
}

// if(location.href.includes('192')){
//     baseURL = "https://apisdev"+base;
// }

const axiosApi = axios.create({
    baseURL,
    timeout: 10 * 1000, // 请求超时时间
    withCredentials: true, // Check cross-site Access-Control
})

// 请求拦截器 
axiosApi.interceptors.request.use(
    (config) => {
        if (config.method === "post") {
            // 修改 Content-Type
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
            // 将对象参数转换为序列化的 URL 形式（key=val&key=val） 
            config.data = stringify(config.data);
        }

        config.headers['Authorization'] = token || (store&&store.state&&store.state.user&&store.state.user.user_app_token ? 'Bearer '+store.state.user.user_app_token : '');

        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);

// 添加响应拦截器
axiosApi.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    let config = response.config;
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export const get = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        let ParmamsObj = {
        }
        let queryObj = {
            channel_code,
            device_id,
            love_stock_pro_is_show_all,
            source,
            appversion:'11.8.0',
            user_id,
            u_id,
            origin_user_id,
            bundle_name
        }
        Object.keys(queryObj).map((item, i) => {
            if (queryObj[item]) {
                ParmamsObj[item] = queryObj[item]
            }
        })
        axiosApi
            .get(url, {
                params: {
                    ...ParmamsObj,
                    ...params,
                }
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
};
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const post = ({ url, params }) => {
    return new Promise((resolve, reject) => {
        let ParmamsObj = {
        }
        let queryObj = {
            // channel_code,
            // device_id,
            love_stock_pro_is_show_all,
            source,
            appversion:'11.8.0',
            user_id,
            u_id,
            origin_user_id,
            bundle_name
        }
        Object.keys(queryObj).map((item, i) => {
            if (queryObj[item]) {
                ParmamsObj[item] = queryObj[item]
            }
        })
        axiosApi
            .post(url, {
                Authorization: token,
                ...ParmamsObj,
                ...params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
};
